import React from "react";
import { Link } from "react-router-dom";
import withRole from "../../../../../Providers/AuthProvider/WithRole";

const IntegrationLink = () => {
    return <Link to={"/integrations"}>My Integrations</Link>;
};

export default withRole(IntegrationLink, ["admin"]);
